const common = {
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    },

    alertError(data) {
      if (data.message === "EXPIRED_TOKEN") {
        this.alertExpiredToken();
      } else {
        this.alertCustomError(data.message);
      }
    },

    alertExpiredToken() {
      this.$buefy.dialog.alert({
        title: "Sua sessão expirou",
        message: "Faça login novamente",
        type: "is-danger",
        hasIcon: true,
        icon: "times-circle",
        iconPack: "fa",
        onConfirm: () => this.$router.push("/"),
        onCancel: () => this.$router.push("/")
      });
    },

    alertCustomError(constant) {
      this.$buefy.dialog.alert({
        title: "Erro :(",
        message: this.translateError(constant),
        type: "is-primary",
        hasIcon: true,
        icon: "exclamation-triangle",
        iconPack: "fa"
      });
    },

    alertReportDowloadMessage(title, message) {
      this.$buefy.dialog.alert({
        title: title || "Pedido recebido",
        message:
          message ||
          "Seu relatório está sendo gerado, você receberá um link por e-mail",
        confirmText: "Ok",
        type: "is-success",
        hasIcon: true,
        icon: "check",
        iconPack: "fa"
      });
    },

    translateError(message) {
      const translations = {
        ACCOUNT_NOT_ACTIVE:
          "Só é possível redefinir a senha após ativar a conta. Por favor, clique no link de ativação que enviamos no seu e-mail.",
        COULD_NOT_SET_STORE_CASHBACK:
          "Não foi possível definir cashback para a loja",
        COULD_NOT_UPDATE_STORE_STATUS:
          "Não foi possível alterar o status da loja",
        INVALID_DATE: "Data inválida",
        INVALID_EMAIL: "E-mail inválido",
        INVALID_EMAIL_VALIDATION_TOKEN:
          "Token inválido ou expirado. Por favor, entre em contato com a Onii pelo contato@onii.com.br",
        INVALID_CREDENTIALS: "Credenciais inválidas.",
        INVALID_PERCENTAGE:
          "Percentual inválido, digite um número inteiro entre 0 e 100, sem zeros à esquerda.",
        INVALID_REQUEST: "Requisição inválida",
        INVALID_STATUS: "Status inválido",
        INVALID_STORE_ID: "ID de loja inválido",
        INVALID_STORES_ORDER: "Ordem inválida",
        INVALID_USER_ID: "ID de usuário inválido",
        MESSAGE_CANNOT_BE_EMPTY: "A mensagem não pode ser vazia",
        PASSWORD_TOO_SHORT: "A senha precisa ter, no mínimo, 6 caracteres.",
        PASSWORDS_DONT_MATCH: "A senha está diferente da confirmação de senha.",
        STORE_NOT_FOUND: "Loja não encontrada",
        TOO_MANY_LOGIN_ATTEMPTS:
          "Você atingiu o limite de 5 tentativas malsucedidas de login a cada 5 minutos. Por segurança, aguarde 5 minutos para tentar novamente ou redefina sua senha.",
        USER_ALREADY_IN_LIST: "Usuário já está na lista",
        USER_NOT_FOUND: "Usuário não encontrado",
        UNEXPECTED_ERROR: "Por favor, tente novamente mais tarde..",
        WRONG_PASSWORD: "Senha atual incorreta!"
      };
      return translations[message] || "Por favor, tente novamente mais tarde..";
    }
  }
};

export { common };
